<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableRedisResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      companyId: "",
      accountName: "",
      instanceName: "",
      columns: [
        {
          title: this.$t("RAM.AWS.ElasticCache.accountID"),
          minWidth: 150,
          key: "accountIdStr"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.accountName"),
          minWidth: 150,
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.region"),
          minWidth: 150,
          key: "region"
        },
        {
          title: this.$t("RAM.ALI.Redis.instanceId"),
          minWidth: 150,
          key: "redisInstanceId"
        },
        {
          title: this.$t("RAM.ALI.Redis.instanceName"),
          minWidth: 150,
          key: "redisInstanceName"
        },
        {
          title: this.$t("RAM.ALI.Redis.connectionDomain"),
          minWidth: 150,
          key: "connectionDomain"
        },
        {
          title: this.$t("RAM.ALI.Redis.instanceStatus"),
          minWidth: 150,
          key: "instanceStatusName"
        },
        {
          title: this.$t("RAM.ALI.Redis.instanceClass"),
          minWidth: 150,
          key: "instanceClass"
        },
        {
          title: this.$t("RAM.AWS.ElasticCache.engine"),
          minWidth: 150,
          key: "engine"
        },
        {
          title: this.$t("RAM.ALI.Redis.engineVersion"),
          minWidth: 150,
          key: "engineVersion"
        },
        {
          title: this.$t("RAM.ALI.Redis.architectureType"),
          minWidth: 150,
          key: "architecturetypeName",
          fixed: "right"
        }
      ],
      tableData: []
    };
  },
  beforeCreate: function() {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function(companyId) {
      tableDataVue.companyId = companyId;
    });
    eventBus.$on("accountName", function(accountName) {
      tableDataVue.accountName = accountName;
    });
    eventBus.$on("instanceName", function(instanceName) {
      tableDataVue.instanceName = instanceName;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .pagingQueryAliRedis({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableDataVue.companyId,
          accountName: tableDataVue.accountName,
          redisInstanceName: tableDataVue.instanceName
        })
        .then(res => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/redis/TableRedisResource.vue